import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { receiveProductsWrapper } from '../Actions/LoadMore.action';
import LoadMoreButton from '../Components/LoadMoreButton';
import ProgressBar from '../Components/ProgressBar';
import { translate } from '../Services/translation';

export default (props) => {
  const { productsWrapper } = useSelector((state) => state.productsView);
  const { products, pagination } = productsWrapper;
  const pageSize = pagination.pageSize;
  const totalProducts = pagination.totalCount;
  const filters = useSelector((state) => state.facetedSearch.facetFilters);
  const allSelectedOptions = useMemo(() => {
    return filters.reduce((accumulator, filter) => {
      if (Array.isArray(filter.selectedOptions) && filter.selectedOptions.length > 0) {
        const { id, selectedOptions } = filter;
        accumulator[id] = selectedOptions;
      }
      return accumulator;
    }, {});
  }, [filters]);
  const dispatch = useDispatch();

  const onLoaded = (res) => {
    dispatch(
      receiveProductsWrapper({
        ...res.result.productsWrapper,
        products: [...products, ...res.result.productsWrapper.products],
      })
    );
  };

  useEffect(() => {
    const url = new URL(location.href);
    url.searchParams.set('products', products?.length ?? pageSize);
    window.history.replaceState(null, document.title, url);
  }, [products, pageSize]);

  var notAllLoaded =
    totalProducts != products.length && totalProducts > pageSize;

  return (
    <>
      {notAllLoaded && (
        <LoadMoreButton
          {...props}
          skip={products.length}
          take={pageSize}
          totalProducts={totalProducts}
          onLoaded={onLoaded}
          pageSize={pageSize}
          filters={allSelectedOptions}
        />
      )}
      <ProgressBar progress={products.length} max={totalProducts} />
      <div className="load-more-products__count-text text-medium">
        <span id="shown-products-counter">
          {products.length < totalProducts ? products.length : totalProducts}
        </span>{' '}
        {translate('global.of').toLowerCase()} {totalProducts}{' '}
        {translate('global.products').toLowerCase()}
      </div>
    </>
  );
};
